export default __webpack_public_path__ + "static/media/20.f45698e9.png";